/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/*
 * Show the loading on all the page
 */
var $ = require('jquery');
var rootScope = require('./root-scope.service');
var submitButtonService = require('./submit-button');
var domService = require('./dom.service');
var fullPageLoadingClassName = 'op-payment-widget-full-loading';
var paymentLoadingId = 'paymentLoadingIcon';

var loadingSvg =
    '<div class="loading-container">' +
    '<svg class="MuiCircularProgress-svg" viewBox="22 22 44 44">' +
    '<circle class="MuiCircularProgress-circle" cx="44" cy="44" r="20.2" fill="none" stroke-width="3.6"></circle>' +
    '</svg>' +
    '</div>';
function getLoadingInContainerClass() {
    return rootScope.getIsFullPageLoading() ? '' : ' loadingInContainer';
}

/**
 * Add full page loading and/or make it visible
 */
function showFullPageLoading() {
    if (!$('.' + fullPageLoadingClassName).length) {
        rootScope
            .getMainContainer()
            .append($('<div class="' + fullPageLoadingClassName + getLoadingInContainerClass() + '">' + loadingSvg + '</div>'));
    } else {
        $('.' + fullPageLoadingClassName).show();
    }
    submitButtonService.disableSubmitButton();
}

/**
 * Hide the full page loading
 */
function hideFullPageLoading() {
    rootScope.resetRemainingProcess();
    $('.' + fullPageLoadingClassName).hide();

    var networkCode = rootScope.getSelectedNetworkCode();
    var formContainer = $(domService.getFormContainerId(networkCode, rootScope.getAllNetworks()));
    if (formContainer.length && networkCode) {
        submitButtonService.disableButtonUneditable(formContainer, networkCode);
    }
}

function handleLoadingOnProcessDone() {
    rootScope.decreaseRemainingProcess();
    if (rootScope.isNoRemainingProcess()) {
        hideFullPageLoading();
    }
}

/**
 * Add payment loading and/or make it visible
 */
function showPaymentLoading() {
    if (!$('#' + paymentLoadingId).length) {
        $(rootScope.getListContainer()).append(
            $('<div id="' + paymentLoadingId + '" class="' + getLoadingInContainerClass() + '">' + loadingSvg + '</div>')
        );
    } else {
        $('#' + paymentLoadingId).show();
    }
}

/**
 * Hide the payment loading
 */
function hidePaymentLoading() {
    rootScope.enableSpecialButton();
    $('#' + paymentLoadingId).hide();
}

function submitButtonNormal() {
    submitButtonService.enableSubmitButton();
    hidePaymentLoading();
}

function submitButtonInProgress() {
    var submitButton = rootScope.getSubmitButton();
    submitButtonService.disableSubmitButton();
    showPaymentLoading(submitButton);
}

function isLoadingState() {
    var paymentLoading = $('#' + paymentLoadingId);
    var fullPageLoading = $('.' + fullPageLoadingClassName);
    return (paymentLoading && paymentLoading.is(':visible')) || (fullPageLoading && fullPageLoading.is(':visible'));
}

module.exports = {
    showFullPageLoading,
    hideFullPageLoading,
    showPaymentLoading,
    hidePaymentLoading,
    handleLoadingOnProcessDone,
    submitButtonNormal,
    submitButtonInProgress,
    isLoadingState,
    getLoadingInContainerClass,
};
